import Vue from 'vue';
import Vuex from 'vuex';
import 'whatwg-fetch';
import {
  searchDictionary,
  loadDictionary,
} from './dict';

Vue.use(Vuex);

let loadedDictionary = {};

const existingWord = window.location.hash.slice(1);

const store = new Vuex.Store({
  state: {
    word: existingWord,
    loadedPercent: 0,
    hasRunSearch: false,
    extensions: [],
    performance: {
      loadDictionary: {
        start: undefined,
        end: undefined,
      },
      searchDictionary: {
        start: undefined,
        end: undefined,
      },
    },
  },
  getters: {
    loadDictionaryTime(state) {
      return state.performance.loadDictionary.end - state.performance.loadDictionary.start;
    },
    searchDictionaryTime(state) {
      return state.performance.searchDictionary.end - state.performance.searchDictionary.start;
    },
  },
  mutations: {
    startPerformanceMeasurement(state, type) {
      const measurement = {
        start: +new Date(),
        end: undefined,
      };
      state.performance = { ...state.performance, [type]: measurement };
      return state;
    },

    endPerformanceMeasurement(state, type) {
      const measurement = {
        ...state.performance[type],
        end: +new Date(),
      };
      state.performance[type] = measurement;
      return state;
    },

    setQuery(state, word) {
      state.word = word;
      if (window.history) {
        window.history.replaceState(undefined, undefined, `#${word}`);
      }
      if (word) {
        state.hasRunSearch = true;
      }
      return state;
    },

    setLoadedPercent(state, percent) {
      state.loadedPercent = percent;
      return state;
    },

    setExtensions(state, extensions) {
      state.extensions = extensions;
      return state;
    },
  },
  actions: {
    findExtensionWords({ commit }, word) {
      // TODO: Cancel in-flight requests if present.

      const query = word.trim().toLowerCase();
      commit('setQuery', query);

      if (Object.keys(loadedDictionary).length === 0) {
        return;
      }

      if (query.length === 0) {
        commit('setExtensions', []);
        return;
      }

      store.commit('startPerformanceMeasurement', 'searchDictionary');
      searchDictionary(loadedDictionary, query).then((extensions) => {
        store.commit('endPerformanceMeasurement', 'searchDictionary');
        commit('setExtensions', extensions);
      });
    },
  },
});


function init() {
  store.commit('startPerformanceMeasurement', 'loadDictionary');
  loadDictionary(store.commit).then((dictionary) => {
    store.commit('endPerformanceMeasurement', 'loadDictionary');
    loadedDictionary = dictionary;
    store.dispatch('findExtensionWords', store.state.word);
  });
}

export default store;
init();



// WEBPACK FOOTER //
// ./src/store/index.js